<template>
  <div>
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="
        $browserDetect && $browserDetect.isFirefox ? true : false
      "
      :preview-modal="false"
      :paginate-elements-by-height="1400"
      :filename="
        'Industry Market Profile - ' +
          (this.$route.path.includes('sample')
            ? 'sample'
            : this.$route.params.id)
      "
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="landscape"
      pdf-content-width="1150px"
      ref="html2PdfFile2"
      @beforeDownload="beforeDownload($event)"
      @hasDownloaded="afterDownload($event)"
    >
      <section slot="pdf-content">
        <div class="pdf_docs prfl-pdf" ref="document">
          <section ref="page1" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div class="banner page">
              <div class="section_body">
                <img src="/img/pdf_logo.png" alt="" class="company_logo" />
                <h1>Industry Market 2- File</h1>
                <ul>
                  <li>
                    Sector: <span>{{ headerInfo.headerData.sector }}</span>
                  </li>
                  <li>
                    Market Area: <span>{{ headerInfo.headerData.area }}</span>
                  </li>
                </ul>
              </div>
              <div class="banner_footer">
                <!-- <h6>American Author</h6>-->
                <span class="author"><!--Joyce Meyer--> </span>
                <span class="date">{{
                  moment(new Date()).format("MMM Do YYYY")
                }}</span>
              </div>
            </div>
          </section>
          <section ref="page2" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div
              class="pdf_docs prfl-pdf page"
              style="overflow:visible !important; clear:both"
              ref="document"
            >
              <div class="about_info">
                <div class="section_body">
                  <div class="section_title">
                    <h2>About the Data</h2>
                    <span class="date">{{
                      moment(new Date()).format("MMM Do YYYY")
                    }}</span>
                  </div>
                  <div class="negetive_margin">
                    <div class="md-layout mt-4 mb-4">
                      <div class="md-layout-item md-size-50">
                        <div class="blue-box">
                          <span>Bizminer</span> data is widely accepted for
                          industry analytical work, benchmarking, valuations,
                          forensics and litigation. Bizminer content is accepted
                          in US Tax Court (Bauer vs. IRS: T.C. Memo. 2012-156)
                          and is utilized by state, provincial and national
                          taxing agencies in the US and Canada.
                        </div>
                      </div>
                      <div class="md-layout-item md-size-50 info-text">
                        <p>
                          Raw data analyzed for Bizminer reports is sourced from
                          an array of the nation's government and private
                          statistical sources. None of these raw data sources
                          creates the final measures reflected in Bizminer
                          industry profiles. In total, Bizminer accesses over a
                          billion sourced data points from 15 million business
                          operations for each of its twice annual updates
                          covering a 3-5 year time series. Historical data and
                          Bizminer algorithms are used to inform and test
                          projections for non-reporting firms. Data elements are
                          sourced specifically from:
                        </p>

                        <p>
                          While 100% firm coverage is desirable for analysis
                          purposes, the greatest value of Bizminer reports rests
                          in discerning patterns of activity, which are
                          reflected in the large samples used to develop our
                          reports. The overall current coverage of the databases
                          surpasses 13 million active business operations at any
                          point in time. As is the case with any databases this
                          large, some errors are inevitable. Some firms are
                          missed and specific information on others is lacking
                          from the database. Not all information received is
                          uniform or complete, resulting in the need to develop
                          projection algorithms for specific industry segments
                          and metrics in some report series. No representation
                          is made as to the accuracy of the databases utilized
                          or the results of subsequent analyses.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="list_box purple-tick">
                    <ul>
                      <li>IRS Statistics of Income</li>
                      <li>IRS SOI Corporation Tax Book</li>
                      <li>IRS Statistics of Income</li>
                      <li>US Economic Census</li>
                      <li>US Census Quarterly Financial Reports</li>
                      <li>US Census County Business Patterns</li>
                      <li>
                        Bureau of Labor Statistics Monthly Employment Reports
                      </li>
                      <li>
                        Bureau of Labor Statistics Monthly Unemployment Reports
                      </li>
                      <li>Bureau of Labor Statistics Annual Wage Survey</li>
                      <li>
                        Bureau of Labor Statistics Industry Productivity Reports
                      </li>
                      <li>Bureau of Labor Statistics Price Indices</li>
                      <li>National Agricultural Statistical Service</li>
                      <li>US Census Quarterly Financial Reports</li>
                      <li>US Census Retail Trade Report</li>
                      <li>Data Axle</li>
                      <li>Business Valuation Resources (BVR)</li>
                      <li>Business Valuation Resources (BVR)</li>
                      <li>Credit Reporting Agencies</li>
                      <li>Business Directories</li>
                      <li>American Community Survey</li>
                    </ul>
                  </div>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page3" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div
              class="pdf_docs prfl-pdf page"
              style="overflow:visible !important; clear:both"
              ref="document"
            >
              <div class="section_body">
                <div class="table_sec">
                  <div class="tbl-title">
                    <h4>Industry Market Report Series - Concentration Data</h4>
                  </div>
                  <table>
                    <tr>
                      <th
                        :key="index"
                        v-for="(item, index) in imrFile2.penetration.table
                          .columns"
                      >
                        <div>
                          {{ item == "name" ? "MARKET PENETRATION ($)" : item }}
                        </div>
                      </th>
                      <th
                        :key="index"
                        :class="item == 'name' ? 'd-none' : ''"
                        v-for="(item, index) in imrFile2.penetration_update
                          .table.columns"
                      >
                        <div :class="item == 'name' ? 'd-none' : ''">
                          {{ item }}
                        </div>
                      </th>
                    </tr>
                    <tr
                      :key="index"
                      v-for="(item, index) in imrFile2.penetration"
                    >
                      <td
                        :class="index == 'table' ? 'd-none' : ''"
                        :key="index2"
                        v-for="(item2, index2) in imrFile2.penetration[index]
                          .columns"
                      >
                        {{ imrFile2.penetration[index].data[0][item2] }}
                      </td>

                      <td
                        :key="index2"
                        :class="
                          item2 == 'name' || index == 'table' ? 'd-none' : ''
                        "
                        v-for="(item2, index2) in imrFile2.penetration_update[
                          index
                        ].columns"
                      >
                        {{ imrFile2.penetration_update[index].data[0][item2] }}
                      </td>
                    </tr>
                  </table>

                  <div class="tbl-title">
                    <h4>Industry Concentrations (% of Area Economy)</h4>
                  </div>
                  <table>
                    <tr>
                      <th
                        :key="index"
                        v-for="(item, index) in imrFile2.concentrations.table
                          .columns"
                      >
                        <div :class="item == 'name' ? 'd-none' : ''">
                          {{ item }}
                        </div>
                      </th>
                      <th
                        :key="index"
                        :class="item == 'name' ? 'd-none' : ''"
                        v-for="(item, index) in imrFile2.concentrations_update
                          .table.columns"
                      >
                        <div :class="item == 'name' ? 'd-none' : ''">
                          {{ item }}
                        </div>
                      </th>
                    </tr>
                    <tr
                      :key="index"
                      v-for="(item, index) in imrFile2.concentrations.table
                        .data"
                    >
                      <td
                        :key="index2"
                        v-for="(item2, index2) in imrFile2.concentrations.table
                          .columns"
                      >
                        {{ imrFile2.concentrations.table.data[index][item2] }}
                      </td>
                      <td
                        :key="index2"
                        :class="item2 == 'name' ? 'd-none' : ''"
                        v-for="(item2, index2) in imrFile2.concentrations_update
                          .table.columns"
                      >
                        {{
                          imrFile2.concentrations_update.table.data[index][
                            item2
                          ]
                        }}
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
          <section ref="page4" slot="pdf-content" class="pdf_docs prfl-pdf">
            <div
              class="pdf_docs prfl-pdf page"
              style="overflow:visible !important; clear:both"
              ref="document"
            >
              <div class="section_body">
                <div class="table_sec">
                  <div class="tbl-title">
                    <h4>Economic Sector Concentrations</h4>
                  </div>
                  <table>
                    <tr>
                      <th class="back-ground-dark-blue">Sector</th>
                      <th class="back-ground-dark-blue">Market Area</th>
                      <th class="back-ground-dark-blue">Sector</th>
                      <th class="back-ground-dark-blue">Market Area</th>
                    </tr>
                    <tr>
                      <td>Agriculture-Forestry-Fishing-Hunting</td>
                      <td>0.25%</td>
                      <td>Real Estate- Rental and Leasing</td>
                      <td>4.78%</td>
                    </tr>
                    <tr>
                      <td>Mining-Quarrying- Oil & Gas Extraction</td>
                      <td>0.20%</td>
                      <td>Professional-Scientific-Technical Services</td>
                      <td>9.32%</td>
                    </tr>
                    <tr>
                      <td>Utilities</td>
                      <td>0.16%</td>
                      <td>Management- Companies & Enterprises</td>
                      <td>0.25</td>
                    </tr>
                    <tr>
                      <td>Construction</td>
                      <td>7.95%</td>
                      <td>Administrative-Support-Waste-Remediation</td>
                      <td>4.37%</td>
                    </tr>
                    <tr>
                      <td>Manufacturing</td>
                      <td>3.67%</td>
                      <td>Educational Services</td>
                      <td>2.90%</td>
                    </tr>
                    <tr>
                      <td>Wholesale Trade</td>
                      <td>3.02%</td>
                      <td>Health Care-Social Assistance</td>
                      <td>20.02%</td>
                    </tr>
                    <tr>
                      <td>Retail Trade</td>
                      <td>15.07%</td>
                      <td>Arts-Entertainment- Recreation</td>
                      <td>1.88%</td>
                    </tr>
                    <tr>
                      <td>Transportation-Warehousing</td>
                      <td>1.76%</td>
                      <td>Accommodation-Food Services</td>
                      <td>5.71%</td>
                    </tr>
                    <tr>
                      <td>Information</td>
                      <td>1.84%</td>
                      <td>Other Services</td>
                      <td>11.04%</td>
                    </tr>
                    <tr>
                      <td>Finance and Insurance</td>
                      <td>5.80%</td>
                      <td>Total</td>
                      <td>100%</td>
                    </tr>
                  </table>
                </div>
              </div>
              <p class="common_footer footer-formatting">
                Copyright © 2022 Bizminer. All Rights Reserved.
              </p>
            </div>
          </section>
        </div>
      </section>
    </VueHtml2pdf>
  </div>
</template>
<script>
import { ChartCard } from "@/components";
import LineChartSimple from "@/components/LineChartSimple.vue";
import LineChartMulti from "@/components/LineChartMulti.vue";
import BarChart from "@/components/BarChart.vue";
import VueHtml2pdf from "vue-html2pdf";
import { mapState } from "vuex";
import moment from "moment";

export default {
  methods: {
    formatData(imr) {
      var teste = imr.concentrations.table.data.map((el) => {});
    },
    reverseArray(a) {
      var rA = [];
      for (var i = a.length; i > 0; i--) {
        rA.push(a[i - 1]);
      }

      return rA;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
      this.$store.commit("user/SET_PDF_LOADING_2", false);
    },
    onProgress($e) {},
    async beforeDownload({ html2pdf, options, pdfContent }) {
      this.$store.commit("user/SET_PDF_LOADING_2", true);

      let page1 = this.$refs.page1;
      let page2 = this.$refs.page2;
      let page3 = this.$refs.page3;
      let page4 = this.$refs.page4;

      let pages = [page1, page2, page3, page4];

      var worker = html2pdf()
        .set(options)
        .from(pages[0])
        .toPdf();
      pages.slice(1).forEach(function(page) {
        worker = worker
          .get("pdf")
          .then(function(pdf) {
            pdf.addPage();
          })
          .from(page)
          .toContainer()
          .toCanvas()
          .toPdf();
      });
      worker.get("pdf").then((pdf) => {
        if (this.$store.getters["user/pdfMustBeDownloaded"]) worker.save();
        else window.open(pdf.output("bloburl"), "_blank");
      });
    },
    async afterDownload() {
      this.$store.commit("user/SET_PDF_LOADING_2", false);
    },
    filterNode(node) {
      if (node instanceof Text) {
        return true;
      }
      return (
        [
          "div",
          "span",
          "p",
          "i",
          "strong",
          "main",
          "aside",
          "article",
          "pre",
          "code",
          "time",
          "address",
          "header",
          "footer",
        ].includes(node.tagName.toLowerCase()) ||
        /^h[123456]$/i.test(node.tagName)
      );
    },
    convertImages() {},
  },
  components: {
    VueHtml2pdf,
    /*  // ChartCard,
          IFPdfIncomeStatement,
          IFPdfBalanceSheet,
          IFPdfSourcesUsers,
         IFPdfRatios,
         LineChart*/
  },
  props: ["headerInfo", "category", "imrFile2"],
  data() {
    return {
      tableInfo: [
        {
          id: "Low",
          name: "Q1",
        },
        {
          id: "Med",
          name: "Median",
        },
        {
          id: "High",
          name: "Q3",
        },
      ],
      moment: moment,
      chartInfo: false,
      chartLoaded: false,
      xaxis: {
        labels: {
          style: {
            colors: ["#FFFFFF"],
          },
        },
      },
    };
  },

  computed: {
    user() {
      return this.$store.state.user.user;
    },
    pdfDownloadSetting() {
      return this.user &&
        this.user.preferences &&
        this.user.preferences.defaultPDFDownload
        ? this.user.preferences.defaultPDFDownload
        : "_blank";
    },
    chartData() {
      return [
        {
          name: "series-1",
          data: this.reverseArray(
            this.chartInfo.colouredLineChart.data.series[0]
          ),
        },
      ];
    },
  },
  watch: {
    information: function(newVal, oldVal) {
      // watch it
      this.chartLoaded = true;
      this.chartInfo = newVal;
    },
    headerInfo: function(newVal, oldVal) {},
    category: function(newVal, oldVal) {},
    imrFile2: function(newVal, oldVal) {
      //    if(newVal){
      //        this.formatData(newVal)
      //     }
    },
  },
};
</script>
